export default __webpack_public_path__ + "static/media/news_1.ebd8dc75.png";